import useMediaQuery, { Breakpoint } from '@/hooks/useMediaQuery';

import ProfileDesktop from './_layouts/ProfileDesktop';
import ProfileMobile from './_layouts/ProfileMobile';

export default function Profile() {
  const isTablet = useMediaQuery(Breakpoint.Tablet);

  return (
    <div>
      {isTablet ? <ProfileDesktop /> : <ProfileMobile />}
    </div>
  );
}
